import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material';

import { IBaseListView } from '../../../../icemedx-lib/src/components/baseview.component';
import { IIceEntity } from 'projects/icemedx-lib/src/models/core/IceEntity';

import {
  IcecontrolSettings,
  IcemattableSettings,
  IcepanelgroupSettings,
  IcepanelsectionSettings,
  IcepanelSettings,
  IcepanelcontainerRowSettings,
  IcepanelcontainerSettings,

  iceColumnDefinition
} from '../../../../icemedx-lib/src/components/models/icesettings';

import { AppService } from '../app.service';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { userTypes } from '../../../../icemedx-lib/src/login/login.config';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';
import { DomainService } from 'projects/icemedx-lib/src/services/domain/domain.service';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { Iceutility } from 'projects/icemedx-lib/src/services/iceutility';
import { PatientService } from '../../../../icemedx-lib/src/services/patient/patient.service';

@Component({
  selector: 'app-phrsettings',
  templateUrl: './phrsettings.component.html',
  styleUrls: ['./phrsettings.component.scss'],
  providers: [AppService, IceNavService]
})
export class PhrsettingsComponent implements OnInit, IBaseListView {

  // Data members
  memberAry: any[] = null;
  privateMemberDataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);

  privateNetworkSettings: IcecontrolSettings = new IcecontrolSettings("PrivateNetworkButton", { text: "Manage Patient Portal Members", class: [], glyphClass: "fa-users" }, null, null);
  registerMemberSettings: IcecontrolSettings = new IcecontrolSettings("RegisterMemberButton", { text: "Add New Patient Portal Member", class: [], glyphClass: "fa-user" }, null, null);
  privateMemberListSettings: IcepanelcontainerSettings = null;

  privateNetworkAccess: boolean = false;

  constructor(private appSvc: AppService, private loginSvc: LoginService, private navSvc: IceNavService, private domainSvc: DomainService, private router: Router) {

    this.appSvc.defaultMenus();
    this.appSvc.addBreadcrumb("Settings", {}, true, "");

    domainSvc.getMembersList(this.appSvc.getCurrentAccountType() == IceTypes.ACCOUNT_TYPE.actPatient ? appSvc.getCurrentAccount() : appSvc.getCurrentPatient(), IceTypes.ACCOUNT_TYPE.actPatient).subscribe(
      data => {
        this.privateMemberListSettings = this.viewSetup(data != null && data.length > 0 ? data : []);
      },
      error => {
      });

    let userInfo = this.loginSvc.GetSessionUserInfo();
    if (this.appSvc.getCurrentAccountType() == IceTypes.ACCOUNT_TYPE.actPatient) {
      let grp: userTypes.USER_GROUPS = this.loginSvc.getHighestGroup(userInfo, appSvc.getCurrentAccount());
      if (grp >= userTypes.USER_GROUPS.upAD) {
        this.privateNetworkAccess = true;
      }
    }
    else {
      let feaAccess: userTypes.USER_FEATURE_ACCESS = userTypes.USER_FEATURE_ACCESS.ufaNone;
      feaAccess = this.loginSvc.getFeatureAccess(userInfo, appSvc.getCurrentAccount(), userTypes.USER_FEATURES.ufPHR);
      if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaFullControl) {
        this.privateNetworkAccess = true;
      }
    }
  }

  ngOnInit() {
    this.appSvc.refreshMenus();
  }

  viewSetup(dat: IIceEntity[]): IcepanelcontainerSettings {
    let setup: IcepanelcontainerSettings = null;
    try {
      if (dat == null) {
        return null;
      }

      this.memberAry = dat;

      //////////////////////
      // Appointment
      let apptTables: IcemattableSettings[] = [
        new IcemattableSettings(
          "MemberTable",
          [
            new iceColumnDefinition("first_name", "Name", false, false,
              new IcecontrolSettings("icelabel", { width: "150px" }, null, null)),
            new iceColumnDefinition("last_name", "", false, false,
              new IcecontrolSettings("icelabel", { width: "150px" }, null, null)),
            new iceColumnDefinition("login_user_name", "Member ID", false, false,
              new IcecontrolSettings("icelabel", { width: "150px" }, null, null)),
            new iceColumnDefinition("login_user_name", "login_user_name", true),
          ],
          this.privateMemberDataSource,
          [],
          false,
          null,
          false
        )
      ];
      let apptGroups: IcepanelgroupSettings[] = [
        new IcepanelgroupSettings(null, apptTables)
      ];

      this.privateMemberDataSource.data = this.memberAry;

      let apptSections: IcepanelsectionSettings[] = [
        new IcepanelsectionSettings("MemberViewSection", { class: ["yalla"], styles: { width: "100%" } }, apptGroups, [], null)
      ];

      let panels: IcepanelSettings[] = [
        new IcepanelSettings("MemberView", "", "Patient Portal Members", "", apptSections, null),
      ];

      let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
      setup = new IcepanelcontainerSettings("MemberViewContainer", panelrows);
    }
    catch (e) {
      console.log(e);
    }
    return setup;
  }

  onPrivateNetwork(event) {
    let act: string = this.appSvc.getCurrentAccount();
    let acttype: IceTypes.ACCOUNT_TYPE = this.appSvc.getCurrentAccountType();
    let ptact: string = this.appSvc.getCurrentPatient();

    this.loginSvc.doPrivateNetwork(acttype == IceTypes.ACCOUNT_TYPE.actPatient ? act : ptact,
      IceTypes.ACCOUNT_TYPE.actPatient,
      acttype != IceTypes.ACCOUNT_TYPE.actPatient ? act : "",
      acttype != IceTypes.ACCOUNT_TYPE.actPatient ? acttype : IceTypes.ACCOUNT_TYPE.actNone,
      false);
  }

  onRegisterMember(event) {
    let act: string = this.appSvc.getCurrentAccount();
    let acttype: IceTypes.ACCOUNT_TYPE = this.appSvc.getCurrentAccountType();
    let ptact: string = this.appSvc.getCurrentPatient();

    this.loginSvc.doRegisterMember(acttype == IceTypes.ACCOUNT_TYPE.actPatient ? act : ptact,
      IceTypes.ACCOUNT_TYPE.actPatient,
      acttype != IceTypes.ACCOUNT_TYPE.actPatient ? act : "",
      acttype != IceTypes.ACCOUNT_TYPE.actPatient ? acttype : IceTypes.ACCOUNT_TYPE.actNone,
      false);
  }

  //////////////////////////////////
  // Toolbar Events
  onToolbarMenuItemOpen(event) {
    this.appSvc.onDefaultToolbarMenuItemOpen(event);
  }
  onToolbarMenuItemClick(event) {
    this.appSvc.onDefaultToolbarMenuItemClick(event, this.router);
  }
}
